import React, { useState } from 'react';
import { api, resolveImg } from '../../api';
import ImageUploader from './ImageUploader';
import { Plus, Trash2, Save, X, Pencil } from 'lucide-react';

const empty = { img: '', styleFr: '', styleEn: '', order: 0 };

const GalleryAdmin = ({ content, refresh }) => {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const startNew = () => { setForm({ ...empty, order: (content.gallery?.length || 0) }); setEditing('new'); };
  const startEdit = (g) => { setForm(g); setEditing(g.id); };
  const cancel = () => { setEditing(null); setForm(empty); };

  const save = async () => {
    if (!form.img) { alert('Veuillez téléverser une image'); return; }
    if (editing === 'new') {
      await api.post('/admin/gallery', form);
    } else {
      await api.put(`/admin/gallery/${editing}`, form);
    }
    await refresh();
    cancel();
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer cette image ?')) return;
    await api.delete(`/admin/gallery/${id}`);
    await refresh();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="h-display text-[32px]">Galerie tatouage</h2>
          <p className="text-[13px] text-[#8A8275] mt-1">Ajoutez vos réalisations de tatouage.</p>
        </div>
        <button onClick={startNew} className="btn-primary"><Plus size={14} /> Ajouter</button>
      </div>

      {editing && (
        <div className="bg-[#FAF8F4] border border-[#957340] p-6 mb-8">
          <div className="flex items-center justify-between mb-5">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#957340]">{editing === 'new' ? 'Nouvelle photo' : 'Modifier'}</div>
            <button onClick={cancel}><X size={16} /></button>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <div className="md:col-span-2">
              <ImageUploader value={form.img} onChange={(v) => setForm({ ...form, img: v })} label="Photo du tatouage" />
            </div>
            <Inp label="Style (FR)" value={form.styleFr} onChange={(v) => setForm({ ...form, styleFr: v })} />
            <Inp label="Style (EN)" value={form.styleEn} onChange={(v) => setForm({ ...form, styleEn: v })} />
            <Inp label="Ordre" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: parseInt(v) || 0 })} />
          </div>
          <div className="mt-6 flex gap-3">
            <button onClick={save} className="btn-primary"><Save size={14} /> Enregistrer</button>
            <button onClick={cancel} className="btn-ghost">Annuler</button>
          </div>
        </div>
      )}

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {(content.gallery || []).map((g) => (
          <div key={g.id} className="bg-white border border-[#E8E2D5] overflow-hidden group">
            <div className="aspect-square bg-[#FAF8F4]">
              {g.img && <img src={resolveImg(g.img)} alt={g.styleFr} className="w-full h-full object-cover" />}
            </div>
            <div className="p-3 flex items-center justify-between">
              <div className="text-[12px] text-[#1A1A1A]">{g.styleFr || '—'}</div>
              <div className="flex gap-1">
                <button onClick={() => startEdit(g)} className="p-2 hover:text-[#957340]"><Pencil size={13} /></button>
                <button onClick={() => del(g.id)} className="p-2 hover:text-red-600"><Trash2 size={13} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Inp = ({ label, value, onChange, type = 'text' }) => (
  <label className="block">
    <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{label}</span>
    <input type={type} value={value ?? ''} onChange={(e) => onChange(e.target.value)} className="mt-2 w-full bg-white border border-[#E8E2D5] focus:border-[#957340] outline-none p-3 text-[14px]" />
  </label>
);

export default GalleryAdmin;
